import { configureStore } from '@reduxjs/toolkit';
import authReducer from './state/authSlice';
import uiReducer from './state/uiSlice';
import agentReducer from './state/agentSlice';
import analysisJobsReducer from './state/analysisJobsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    /* The forms and signals the agent fills and fires (UPDATE_* / REQUEST_*). */
    agent: agentReducer,
    /* runInvestmentAnalysis jobs and their unsaved analyses, followed across mounts. */
    analysisJobs: analysisJobsReducer,
  },
});

export default store;
